var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedXec0)",
    d: "M8.876 9.806c.891-.506 1.791-1.037 2.683-1.543a.86.86 0 0 1 .865 0l1.329.716a.12.12 0 0 1 .051.098a.12.12 0 0 1-.056.099l-3.321 1.834a.26.26 0 0 0-.094.095a.26.26 0 0 0-.047.132v1.539c0 .043.021.086.043.129q.04.057.098.09l1.436.767a.24.24 0 0 0 .257 0l5.597-3.163c.947-.54.947-2.096 0-2.636l-5.031-2.846a1.36 1.36 0 0 0-1.393 0L6.266 7.963A1.36 1.36 0 0 0 5.57 9.15c0 1.899.009 3.802 0 5.7a1.33 1.33 0 0 0 .699 1.183l5.027 2.854a1.4 1.4 0 0 0 1.393 0l5.027-2.854a1.35 1.35 0 0 0 .69-1.187v-2.473l-5.983 3.369a.86.86 0 0 1-.433.115a.86.86 0 0 1-.432-.115l-2.58-1.492a.84.84 0 0 1-.322-.308c-.073-.129-.086-.275-.086-.429v-2.979c0-.402.086-.604.305-.728"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedXec0",
    x1: 7.631,
    x2: 15.826,
    y1: 6.06,
    y2: 17.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1355AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DDD"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXec);
export default __webpack_public_path__ + "static/media/xec.e802a766ac47df3cef6cdcfdea8bedd5.svg";
export { ForwardRef as ReactComponent };